export const ROLES = {
  EDITOR: 'account-editor',
  PUBLISHER: 'account-publisher',
  ACCOUNT_ADMIN: 'account-admin',
};
